import { API } from "../../../utils/api";

export async function getExtraOptionAPI({ modelType, periodType }) {
  return (await API.get(`lease/option?modelType=${modelType}&period=${periodType}`)).data
}